module.exports = __webpack_public_path__ + "static/allthingsopenheader-3ed38f936840f7ffeabc759f49158490.jpeg";